import { areAmountValuesEquivalent } from "./overheadsAutosave.model";

export const VALUE_HISTORY_SWITCH_KIND = "value-history-switch";
export const VALUE_HISTORY_SWITCH_REQUESTED = "VALUE_HISTORY_SWITCH_REQUESTED";

export const isValueHistorySwitchIntent = (intent) => intent?.kind === VALUE_HISTORY_SWITCH_KIND;

export const valueHistorySwitchMatchesRecord = ({ intent, valueHistory }) =>
  isValueHistorySwitchIntent(intent) &&
  !!valueHistory &&
  valueHistory.generation === intent.historyGeneration &&
  valueHistory.ownerFieldKey === intent.fieldKey &&
  areAmountValuesEquivalent(valueHistory.currentValue, intent.historyCurrentValue) &&
  areAmountValuesEquivalent(valueHistory.alternateValue, intent.historyAlternateValue);

export const isCurrentPersistenceIntent = ({ intent, valueHistory, field }) => {
  if (!intent || !field) return false;
  if (field.revision !== intent.revision) return false;
  if (!areAmountValuesEquivalent(field.draftValue, intent.draftValue)) return false;
  if (intent.kind === "save") return true;

  if (!valueHistorySwitchMatchesRecord({ intent, valueHistory })) return false;
  return (
    areAmountValuesEquivalent(field.confirmedValue, intent.historyCurrentValue) &&
    areAmountValuesEquivalent(field.draftValue, intent.historyAlternateValue)
  );
};

export const isCurrentCommittedValueHistorySwitch = ({ intent, valueHistory, field }) =>
  !!field && valueHistorySwitchMatchesRecord({ intent, valueHistory }) && areAmountValuesEquivalent(field.confirmedValue, intent.historyCurrentValue);
